export const environment = {
  production: true,
  enableClarity: true,
  name: 'production',
  apiUrl: 'https://iframe-api.docestate.com',
  dataServiceUrl: 'https://iframe-api.docestate.com',
  host: 'https://iframe.docestate.com',
  defaultConfigurationId: 'c4dc7713-060e-49b8-ad35-e5ffa6181023',
  stripe: {
    publicKey: 'pk_live_51JIryUC7AZQFnsXPrpKe6YbZf5DxSqzZ87Vep6Ry10KxQF3hL8PPNvXPEtjt9OLcec3eNg59vCUL3k18s9sTIF3L00UnlKgWeh',
  }
};
